/* ==========================================================================
   פיצי — עוזרת הצ'אט של MyPitz
   assets/pitzi.js

   מנוע התאמה עברי מקומי לחלוטין. בלי שרת, בלי API, בלי עלות לכל שיחה.
   הידע יושב בקבצי assets/pitzi-kb-1..6.js ונטען רק כשפותחים את הצ'אט.

   מבנה:
     1. עזרי טקסט בעברית (ניקוד, אותיות סופיות, תחיליות, סיומות)
     2. אינדקס הפוך + IDF
     3. ניקוד התאמה + טעויות כתיב
     4. כוונות מיוחדות (ברכה, נציג אנושי, סטטוס הזמנה)
     5. תרחישים מונחים (איזה מוצר מתאים לי / איזו מידה)
     6. ממשק, נגישות, שמירת שיחה
   ========================================================================== */
(function () {
  'use strict';

  if (window.__PITZI_LOADED__) return;
  window.__PITZI_LOADED__ = true;

  var KB = window.PITZI_KB || [];
  var CFG = window.PITZI_CONFIG || {};

  /* ---------------------------------------------------------------- config */
  var C = {
    name: CFG.name || 'פיצי',
    subtitle: CFG.subtitle || 'העוזרת של MyPitz · עונה מיד',
    email: CFG.email || 'mypitz3@gmail.com',
    root: CFG.root || '',
    teaserDelay: CFG.teaserDelay == null ? 7000 : CFG.teaserDelay,
    typingMin: 380,
    typingMax: 900
  };

  var T = CFG.text || {};
  var t = function (k, d) { return T[k] != null ? T[k] : d; };

  /* routes.root_url הוא "/" בשפת ברירת המחדל ו-"/en" וכדומה בשפה אחרת.
     בלי הניקוי הזה "/" + "/products/x" היה הופך ל-"//products/x", שהדפדפן
     מפרש ככתובת של דומיין אחר. */
  var ROOT = (C.root === '/' ? '' : String(C.root || '').replace(/\/+$/, ''));
  var U = function (p) {
    if (!p) return '';
    if (/^https?:|^mailto:|^tel:|^#/.test(p)) return p;
    return ROOT + p;
  };

  /* ------------------------------------------------------- טקסט בעברית */
  var NIQQUD = /[֑-ׇ]/g;
  var FINALS = { 'ם': 'מ', 'ן': 'נ', 'ץ': 'צ', 'ף': 'פ', 'ך': 'כ' };
  var PREFIXES = ['ומה', 'ושה', 'כשה', 'מה', 'שה', 'וה', 'ול', 'וב', 'ומ', 'וכ', 'ות', 'לה', 'בה', 'כה',
                  'ה', 'ו', 'ב', 'ל', 'מ', 'כ', 'ש'];
  /* הסיומות כתובות אחרי נרמול האותיות הסופיות: ם→מ, ן→נ.
     "משלוחים" הופך ל"משלוחימ", ולכן הסיומת שצריך לחפש היא ימ ולא ים. */
  var SUFFIXES = ['יות', 'ימ', 'ות', 'תי', 'נו', 'כמ', 'כנ', 'המ', 'הנ', 'יי', 'ה', 'ת', 'י'];

  function norm(s) {
    if (!s) return '';
    return String(s)
      .replace(NIQQUD, '')
      .replace(/[׳״'"`´’‘“”]/g, '')
      .toLowerCase()
      .replace(/[^א-תa-z0-9\s]/g, ' ')
      .replace(/[םןץףך]/g, function (m) { return FINALS[m] || m; })
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* מייצר מפתחות חיפוש לטוקן: המילה עצמה, בלי תחילית, בלי סיומת, ובלי שתיהן */
  function keys(w) {
    var out = [w], i, j, a, b;
    if (w.length < 3) return out;
    for (i = 0; i < PREFIXES.length; i++) {
      if (w.length - PREFIXES[i].length >= 2 && w.indexOf(PREFIXES[i]) === 0) {
        a = w.slice(PREFIXES[i].length);
        if (out.indexOf(a) < 0) out.push(a);
        break;
      }
    }
    var base = out.slice();
    for (j = 0; j < base.length; j++) {
      for (i = 0; i < SUFFIXES.length; i++) {
        b = base[j];
        if (b.length - SUFFIXES[i].length >= 3 && b.slice(-SUFFIXES[i].length) === SUFFIXES[i]) {
          var s = b.slice(0, -SUFFIXES[i].length);
          if (out.indexOf(s) < 0) out.push(s);
          break;
        }
      }
    }
    return out;
  }

  function tokens(s) {
    var raw = norm(s).split(' ').filter(function (w) { return w.length > 1; });
    return raw;
  }

  /* מרחק עריכה עד 1, מוגבל ביציאה מוקדמת */
  function near1(a, b) {
    if (a === b) return true;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, diff = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++diff > 1) return false;
      if (la > lb) i++;
      else if (lb > la) j++;
      else { i++; j++; }
    }
    if (i < la || j < lb) diff++;
    return diff <= 1;
  }

  /* ------------------------------- טעינה עצלה של מאגר הידע ובניית האינדקס

     מאגר הידע הוא כ-400KB של טקסט עברי. הוא לא נטען עם העמוד אלא רק כשהגולשת
     מתקרבת לכפתור או פותחת את הצ'אט, כך שהוא לא מעכב את טעינת האתר בכלל.
     ---------------------------------------------------------------------- */
  var IDX = Object.create(null);   // מפתח -> [אינדקס רשומה, ...]
  var DOC = [];                    // לכל רשומה: שק מילים, טקסט מלא ושאלה מנורמלת
  var IDF = Object.create(null);
  var VOCAB_BY_LEN = Object.create(null);
  var N = 0, AVG_LEN = 1;
  var kbReady = false, kbLoading = false, kbQueue = [];

  function buildIndex() {
    KB = window.PITZI_KB || [];
    IDX = Object.create(null);
    DOC = [];
    var VOCAB = Object.create(null);

    KB.forEach(function (e, ix) {
      var bag = Object.create(null);
      var texts = [e.q].concat(e.v || []);
      var joined = norm(texts.join(' '));
      texts.forEach(function (tx, ti) {
        tokens(tx).forEach(function (w) {
          keys(w).forEach(function (k) {
            // המילים בשאלה הראשית שוקלות מעט יותר
            var wgt = ti === 0 ? 1.15 : 1;
            if (!bag[k] || bag[k] < wgt) bag[k] = wgt;
          });
        });
      });
      DOC[ix] = { bag: bag, text: ' ' + joined + ' ', q: e.q, qn: norm(e.q), len: Object.keys(bag).length };
      Object.keys(bag).forEach(function (k) {
        (IDX[k] || (IDX[k] = [])).push(ix);
        VOCAB[k] = 1;
      });
    });

    N = KB.length;
    IDF = Object.create(null);
    Object.keys(IDX).forEach(function (k) {
      IDF[k] = Math.log(1 + N / IDX[k].length);
    });

    VOCAB_BY_LEN = Object.create(null);
    Object.keys(VOCAB).forEach(function (k) {
      (VOCAB_BY_LEN[k.length] || (VOCAB_BY_LEN[k.length] = [])).push(k);
    });

    AVG_LEN = 0;
    DOC.forEach(function (d) { AVG_LEN += d.len; });
    AVG_LEN = AVG_LEN / (DOC.length || 1) || 1;

    kbReady = true;
  }

  function flushQueue() {
    var q = kbQueue;
    kbQueue = [];
    q.forEach(function (f) { try { f(); } catch (e) { } });
  }

  function loadKB(cb) {
    if (kbReady) { if (cb) cb(); return; }
    if (cb) kbQueue.push(cb);
    if (kbLoading) return;
    kbLoading = true;

    var urls = CFG.kbUrls || [];
    if (!urls.length) { buildIndex(); flushQueue(); return; }

    var left = urls.length;
    urls.forEach(function (u) {
      var s = document.createElement('script');
      s.src = u;
      s.async = true;
      s.onload = s.onerror = function () {
        if (--left === 0) { buildIndex(); flushQueue(); }
      };
      document.head.appendChild(s);
    });
  }

  function fuzzyKeys(w) {
    if (w.length < 4) return [];
    var out = [], pools = [VOCAB_BY_LEN[w.length], VOCAB_BY_LEN[w.length - 1], VOCAB_BY_LEN[w.length + 1]];
    for (var p = 0; p < pools.length; p++) {
      var pool = pools[p];
      if (!pool) continue;
      for (var i = 0; i < pool.length; i++) {
        if (pool[i][0] === w[0] && near1(w, pool[i])) out.push(pool[i]);
        if (out.length > 6) return out;
      }
    }
    return out;
  }

  /* ------------------------------------------------------------ חיפוש */
  function search(query, ctxTags) {
    var qn = norm(query);
    var qt = tokens(query);
    if (!qt.length) return [];

    var scores = Object.create(null);
    var hitCount = Object.create(null);   // כמה מילים שונות מהשאלה נמצאו בכל רשומה
    var totalIdf = 0;
    var strongHit = false;
    var UNKNOWN_W = 1.4;                  // מילה שלא קיימת בידע מדללת את הציון

    qt.forEach(function (w) {
      var ks = keys(w), fuzzyFrom = ks.length;
      var bestIdf = 0;
      ks.forEach(function (k) { if (IDF[k] > bestIdf) bestIdf = IDF[k]; });
      if (!bestIdf) {
        var fz = [];
        ks.forEach(function (k) { fz = fz.concat(fuzzyKeys(k)); });
        fz.forEach(function (k) { if (IDF[k] > bestIdf) bestIdf = IDF[k]; });
        ks = ks.concat(fz);
      }
      totalIdf += bestIdf || UNKNOWN_W;

      var seen = Object.create(null);
      ks.forEach(function (k, ki) {
        var list = IDX[k];
        if (!list) return;
        // התאמה מדויקת עדיפה על גזע, וגזע עדיף בהרבה על ניחוש טעות כתיב
        var pen = ki === 0 ? 1 : (ki >= fuzzyFrom ? 0.45 : 0.82);
        var idf = IDF[k];
        if (idf > 1.1 && ki < fuzzyFrom) strongHit = true;
        for (var i = 0; i < list.length; i++) {
          var ix = list[i];
          var val = idf * pen * DOC[ix].bag[k];
          if (!seen[ix]) hitCount[ix] = (hitCount[ix] || 0) + 1;
          if (!seen[ix] || seen[ix] < val) {
            scores[ix] = (scores[ix] || 0) - (seen[ix] || 0) + val;
            seen[ix] = val;
          }
        }
      });
    });

    if (!strongHit) return [];

    var res = [];
    for (var ix in scores) {
      var i = +ix, s = scores[i] / (totalIdf || 1);
      var d = DOC[i], e = KB[i];

      // שאלה ארוכה שנתפסה על מילה בודדת היא כמעט תמיד התאמה מקרית
      if (qt.length >= 3 && (hitCount[i] || 0) < 2) s *= 0.45;

      // רשומה עם אוצר מילים גדול מתאימה במקרה ליותר שאלות, ולכן מנורמלת מעט כלפי מטה
      s *= Math.pow(AVG_LEN / (d.len || AVG_LEN), 0.18);

      // בונוס לביטוי שלם שמופיע כמו שהוא
      if (qn.length > 5 && d.text.indexOf(' ' + qn + ' ') >= 0) s += 0.45;
      else if (qn.length > 7 && d.text.indexOf(qn) >= 0) s += 0.28;

      // בונוס להקשר: העמוד שהגולשת נמצאת בו עכשיו
      if (ctxTags && ctxTags.length && e.tags) {
        for (var c = 0; c < ctxTags.length; c++) {
          if (e.tags.indexOf(ctxTags[c]) >= 0) { s += 0.14; break; }
        }
      }
      if (e.boost) s += e.boost;

      res.push({ i: i, s: s, e: e });
    }
    res.sort(function (a, b) { return b.s - a.s; });
    return res.slice(0, 8);
  }

  /* ------------------------------------------------- כוונות מהירות */
  var INTENTS = [
    { id: 'greet', re: /^(היי|הי|שלום|אהלן|בוקר טוב|ערב טוב|צהריים טובים|לילה טוב|מה נשמע|מה קורה|הלו|יו|hi|hello|hey|שלום לך)\b/ },
    { id: 'thanks', re: /(תודה|תודה רבה|יפה מאוד|מעולה|סבבה|אחלה|מדהים|thanks|thank you|תודהה)/ },
    { id: 'bye', re: /^(ביי|להתראות|תודה וביי|יאללה ביי|נתראה|bye)\b/ },
    { id: 'human', re: /(נציג|נציגה|בן אדם|בנאדם|אדם אמיתי|לדבר עם מישהו|לדבר עם מישהי|שירות לקוחות|טלפון|וואטסאפ|ווצאפ|whatsapp|לצלצל|להתקשר|מוקד|human|agent)/ },
    { id: 'order', re: /(איפה ההזמנה|מספר מעקב|סטטוס הזמנה|ההזמנה שלי|מעקב אחרי|לא הגיע|לא הגיעה החבילה|החבילה שלי|track|tracking)/ },
    { id: 'finder', re: /(איזה מוצר|מה מתאים לי|איזה פריט|לא יודעת מה לקנות|לא יודע מה לקנות|תעזרי לי לבחור|תעזור לי לבחור|מה כדאי לי|מה הכי מתאים|במה לבחור)/ },
    { id: 'sizer', re: /(איזו מידה|איזה מידה|מה המידה שלי|מידה מתאימה|בין שתי מידות|לא יודעת איזו מידה|לא יודע איזו מידה)/ },
    { id: 'bot', re: /(את בוט|אתה בוט|מי את|מי אתה|את אמיתית|אתה אמיתי|רובוט|בינה מלאכותית|are you a bot|who are you)/ },
    /* שיחת חולין. אלה לא שאלות על החנות, ואין להן תשובה במאגר.
       כשיש מוח הן הולכות אליו, כדי שהתשובה תישמע כמו בן אדם ולא כמו הודעה מוכנה. */
    { id: 'smalltalk', re: /(מה שלומ|מה נשמע|מה קורה|מה המצב|איך את מרגיש|איך אתה מרגיש|מה איתך|איך היה היום|יום קשה|יום ארוך|מצחיק|אהבתי אותך|את חמודה|את מתוקה|כבר לא יכולה|נמאס לי|אני מתה|מבאס|באסה|חחח|הההה|לול|lol)/ },
    { id: 'english', re: /^[a-z0-9\s.,'?!-]{14,}$/ }
  ];

  function detectIntent(s) {
    var n = norm(s);
    for (var i = 0; i < INTENTS.length; i++) {
      if (INTENTS[i].re.test(n)) return INTENTS[i].id;
    }
    return null;
  }

  /* ---------------------------------------------------------- אייקון פיצי */
  var MASCOT = '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M11.2 7.4h2.9a2.4 2.4 0 0 0 3.8 0h2.9c1.8 0 3 1 3.4 2.6l.85 3.2c.24.9-.3 1.75-1.2 1.95l-1.35.3v7.9c0 1.3-.85 2.15-2.15 2.15H11.6c-1.3 0-2.15-.85-2.15-2.15v-7.9l-1.35-.3c-.9-.2-1.44-1.05-1.2-1.95l.85-3.2C8.2 8.4 9.4 7.4 11.2 7.4Z" fill="#FFFFFF"/>' +
    '<circle cx="13.4" cy="17.6" r="1.15" fill="#8A6A46"/>' +
    '<circle cx="18.6" cy="17.6" r="1.15" fill="#8A6A46"/>' +
    '<path d="M13.7 20.8c.75.85 1.45 1.25 2.3 1.25s1.55-.4 2.3-1.25" stroke="#8A6A46" stroke-width="1.35" stroke-linecap="round" fill="none"/>' +
    '<circle cx="11.1" cy="20.1" r="1.05" fill="#F0C9A8" opacity=".85"/>' +
    '<circle cx="20.9" cy="20.1" r="1.05" fill="#F0C9A8" opacity=".85"/>' +
    '<path d="M24.9 5.2l.62 1.62 1.62.62-1.62.62-.62 1.62-.62-1.62-1.62-.62 1.62-.62.62-1.62Z" fill="#FFF3E0"/>' +
    '</svg>';

  var ICON_X = '<svg class="pz-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.996.996 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91Z"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var ICON_RESET = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>';
  var AGENT_ICON = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="8" r="4" fill="#F5F0E8"/><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" fill="#F5F0E8"/></svg>';

  var ICON_AGENT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 13a8 8 0 0 1 16 0"/><path d="M4 14v2a2 2 0 0 0 2 2h1v-6H6a2 2 0 0 0-2 2Z"/><path d="M20 14v2a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2Z"/><path d="M18 18v.5a2.5 2.5 0 0 1-2.5 2.5H13"/></svg>';

  /* ---------------------------------------------------------------- DOM */
  var root, panel, body, input, sendBtn, launcher, teaser, backBtn, liveRegion;
  var isOpen = false, busy = false, flow = null, lastFallback = -1, history = [], lastFocus = null;
  var convo = [];   // זיכרון השיחה שנשלח למוח, כדי ששאלת המשך תובן בהקשר

  var STORE_KEY = 'pitzi_chat_v1';
  var SEEN_KEY = 'pitzi_seen_v1';
  var MISS_KEY = 'pitzi_miss_v1';

  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) { }
    return null;
  }
  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      sessionStorage.setItem(k, v);
    } catch (e) { }
    return null;
  }

  function el(tag, cls, html) {
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    if (html != null) d.innerHTML = html;
    return d;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* -------------------------------------------------------------- הקשר */
  function pageContext() {
    var tags = [], p = decodeURIComponent(location.pathname);
    var m = p.match(/\/products\/([^\/?#]+)/);
    if (m) tags.push('p:' + m[1]);
    if (/\/cart/.test(p)) tags.push('cart');
    if (/\/collections/.test(p)) tags.push('collection');
    if (/\/pages\//.test(p)) tags.push('page');
    return tags;
  }

  /* ------------------------------------------------------------ הצגה */
  function scrollDown(smooth) {
    requestAnimationFrame(function () {
      body.scrollTo ? body.scrollTo({ top: body.scrollHeight, behavior: smooth === false ? 'auto' : 'smooth' })
                    : (body.scrollTop = body.scrollHeight);
    });
  }

  function addRow(who, html) {
    var row = el('div', 'pz-row' + (who === 'me' ? ' pz-me' : ''));
    if (who !== 'me') row.appendChild(el('div', 'pz-mini', MASCOT));
    var bub = el('div', 'pz-bub', html);
    row.appendChild(bub);
    body.appendChild(row);
    scrollDown();
    return row;
  }

  function say(html, opts) {
    opts = opts || {};
    var row = addRow('bot', html);
    if (liveRegion) liveRegion.textContent = row.textContent;
    if (live.id && live.status === 'waiting') noteToAgent('bot', row.textContent.trim().slice(0, 600));
    if (opts.chips) renderChips(opts.chips);
    if (opts.menu) renderMenu();
    return row;
  }

  function typing() {
    var row = el('div', 'pz-row');
    row.appendChild(el('div', 'pz-mini', MASCOT));
    row.appendChild(el('div', 'pz-bub pz-typing', '<i></i><i></i><i></i>'));
    body.appendChild(row);
    scrollDown();
    return row;
  }

  function delay(text) {
    var len = (text || '').length;
    return Math.min(C.typingMax, C.typingMin + len * 4);
  }

  function botSay(html, opts, ms) {
    busy = true;
    var tr = typing();
    setTimeout(function () {
      tr.remove();
      say(html, opts);
      busy = false;
      persist();
    }, ms == null ? delay(html) : ms);
  }

  function renderChips(list) {
    if (!list || !list.length) return;
    var wrap = el('div', 'pz-chips');
    list.forEach(function (c) {
      var label = typeof c === 'string' ? c : c.label;
      var b = el('button', 'pz-chip' + (c.primary ? ' pz-primary' : ''), (c.emoji ? '<span class="pz-em">' + c.emoji + '</span>' : '') + esc(label));
      b.type = 'button';
      b.setAttribute('data-q', label);
      if (c.id) b.setAttribute('data-id', c.id);
      b.addEventListener('click', function () {
        if (busy) return;
        if (c.href) { window.location.href = U(c.href); return; }
        if (c.act) { c.act(); return; }
        ask(label, c.id);
      });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scrollDown();
  }

  var MENU = CFG.menu || [];

  function renderMenu() {
    if (!MENU.length) return;
    var wrap = el('div', 'pz-menu');
    MENU.forEach(function (m) {
      var b = el('button', 'pz-mi', '<i>' + m.icon + '</i><b>' + esc(m.label) + '</b>');
      b.type = 'button';
      b.addEventListener('click', function () {
        if (busy) return;
        openCategory(m);
      });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scrollDown();
  }

  function openCategory(m) {
    addRow('me', esc(m.label));
    persist();
    var qs = (m.questions || []).map(function (q) { return { label: q }; });
    qs.push({ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu });
    botSay('<p>' + esc(m.intro || ('אלה השאלות הנפוצות ב' + m.label + '. אפשר גם פשוט לכתוב לי בחופשיות.')) + '</p>', { chips: qs });
    track('category', m.label);
  }

  function showMenu() {
    botSay('<p>' + esc(t('menuIntro', 'במה נתחיל?')) + '</p>', { menu: true });
  }

  function productCard(h) {
    var p = (CFG.products || {})[h];
    if (!p) return '';
    return '<a class="pz-card" href="' + U(p.url) + '">' +
      (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="52" height="52">' : '') +
      '<span class="pz-card-t"><b>' + esc(p.title) + '</b><span>' + esc(p.price) + '</span>' +
      (p.note ? '<em>' + esc(p.note) + '</em>' : '') + '</span></a>';
  }

  /* ------------------------------------------------------ בניית תשובה */
  function answerHtml(e) {
    var html = (e.a || []).map(function (p) { return '<p>' + p + '</p>'; }).join('');

    if (e.tbl) {
      html += '<div class="pz-scroll"><table class="pz-tbl"><thead><tr>' +
        e.tbl.h.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') +
        '</tr></thead><tbody>' +
        e.tbl.r.map(function (r) {
          return '<tr>' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>';
        }).join('') +
        '</tbody></table></div>';
    }

    if (e.prod) {
      (Array.isArray(e.prod) ? e.prod : [e.prod]).forEach(function (h) { html += productCard(h); });
    }

    if (e.handoff) {
      html += agentButton();
    } else if (e.cta && e.cta.url) {
      html += '<a class="pz-cta" href="' + U(e.cta.url) + '">' + ICON_ARROW + esc(e.cta.label) + '</a>';
    }
    return html;
  }

  function agentButton() {
    return '<button type="button" class="pz-cta pz-agent" data-pz-agent="1">' +
      ICON_AGENT + esc(t('agentLabel', 'לדבר עם נציג אנושי')) + '</button>';
  }

  // הכפתור נשמר כ HTML ונטען מחדש, ולכן ההאזנה נעשית ברמת הגוף ולא על האלמנט
  function wireAgentButtons() {
    body.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('[data-pz-agent]') : null;
      if (!b || busy) return;
      ev.preventDefault();
      if (live.id && live.status !== 'bot') { setBanner(t('waitingBanner', 'העברתי את השיחה לנציג. בינתיים אני כאן.')); return; }
      if (liveAvailable()) requestHuman(false); else humanHandoff();
    });
  }

  /* ---------------------------------------------------- תרחישים מונחים */
  var FINDER = CFG.finder || null;
  var SIZER = CFG.sizer || null;

  function startFlow(def, key) {
    flow = { def: def, step: 0, answers: [], key: key };
    stepFlow();
  }

  function stepFlow() {
    if (!flow) return;
    var s = flow.def.steps[flow.step];
    if (!s) return endFlow();
    botSay('<p>' + s.q + '</p>', {
      chips: s.options.map(function (o) {
        return {
          label: o.label,
          act: function () {
            addRow('me', esc(o.label));
            flow.answers.push(o.value);
            flow.step++;
            persist();
            stepFlow();
          }
        };
      }).concat([{ label: t('cancelFlow', 'לא עכשיו'), act: function () { flow = null; botSay('<p>' + esc(t('flowCancel', 'אין בעיה. אפשר לשאול אותי כל דבר אחר.')) + '</p>', { menu: true }); } }])
    });
  }

  function endFlow() {
    var res = flow.def.resolve(flow.answers);
    var key = flow.key;
    flow = null;
    var html = '<p>' + res.text + '</p>';
    if (res.prod) {
      (Array.isArray(res.prod) ? res.prod : [res.prod]).forEach(function (h) { html += productCard(h); });
    }
    if (res.cta) html += '<a class="pz-cta" href="' + U(res.cta.url) + '">' + ICON_ARROW + esc(res.cta.label) + '</a>';
    botSay(html, { chips: (res.chips || []).map(function (c) { return { label: c }; }).concat([{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }]) });
    track('flow', key);
  }

  /* ------------------------------------------------------------- שאילה */
  function ask(text, forcedId) {
    if (busy) return;
    text = String(text || '').trim();
    if (!text) return;
    addRow('me', esc(text));
    input.value = '';
    autoGrow();
    sendBtn.disabled = true;
    convo.push({ role: 'user', content: text });
    if (convo.length > 12) convo = convo.slice(-12);
    persist();

    // הנציג בשיחה. פיצי לא אומרת מילה, ההודעה עוברת אליו בלבד.
    if (live.status === 'live') {
      sayToAgent(text);
      persist();
      return;
    }
    // ממתינה לנציג. ההודעה עוברת אליו, ופיצי בכל זאת מנסה לעזור בינתיים.
    if (live.status === 'waiting') sayToAgent(text);

    // מאגר הידע נטען רק בפעם הראשונה. עד שהוא מגיע מוצג חיווי הקלדה.
    if (!kbReady) {
      busy = true;
      var waitRow = typing();
      loadKB(function () {
        waitRow.remove();
        busy = false;
        route(text, forcedId);
      });
      return;
    }
    route(text, forcedId);
  }

  /* מגיש רשומה מהמאגר. אם התשובה שלה מפנה לנציג אנושי,
     נפתחת גם שיחה חיה בשקט כדי שתקבל התראה. */
  function serveEntry(e) {
    botSay(answerHtml(e), { chips: followUps(e) });
    track('answer', e.id);
    if (e.handoff && liveAvailable()) requestHuman(true);
  }

  function route(text, forcedId) {
    if (forcedId) {
      var fe = KB.filter(function (x) { return x.id === forcedId; })[0];
      if (fe) { serveEntry(fe); return; }
    }

    // תרחיש פעיל, הקלדה חופשית מבטלת אותו
    if (flow) flow = null;

    var intent = detectIntent(text);
    var nTokens = tokens(text).length;

    /* בקשה לנציג נבדקת לפני הכול, גם לפני התאמה מדויקת במאגר.
       אחרת שאלה כמו "אפשר לדבר עם נציג" הייתה נענית כתשובה רגילה
       מהמאגר, ואתה לא היית מקבל התראה. */
    if (intent === 'human' || intent === 'bot' || intent === 'english') {
      if (handleIntent(intent, text)) return;
    }

    // טקסט שזהה לשאלה קיימת נענה ישירות, בלי מנוע ההתאמה
    var qn0 = norm(text);
    for (var xi = 0; xi < DOC.length; xi++) {
      if (DOC[xi].qn === qn0) {
        serveEntry(KB[xi]);
        return;
      }
    }
    /* ברכה או שיחת חולין. עם מוח, הוא עונה בעצמו וזה נשמע כמו שיחה אמיתית.
       בלי מוח, נופלים לתשובה הקבועה הקצרה. */
    var chatty = (intent === 'greet' || intent === 'thanks' || intent === 'bye');
    if (intent === 'smalltalk' || (chatty && nTokens <= 3)) {
      if (aiAvailable()) {
        /* גם במשפט אישי כמו "נמאס לי מהכתמים" עדיין שולחים למוח את המועמדים
           מהמאגר, כדי שהתשובה תישאר מעוגנת בעובדות ולא רק אמפתית. */
        askAI(text, intent === 'smalltalk' ? search(text, pageContext()) : [], true);
        return;
      }
      if (chatty && handleIntent(intent, text)) return;
      if (intent === 'smalltalk' && handleIntent('greet', text)) return;
    }

    var hits = search(text, pageContext());
    var top = hits[0];

    // שאר הכוונות גוברות רק אם אין התאמה חזקה בידע
    if (intent && (!top || top.s < 0.62)) {
      if (handleIntent(intent, text)) return;
    }

    /* לענות ישירות רק כשההתאמה חזקה, או כשהיא מנצחת בפער ברור.
       בכל מצב אחר עדיף להציע כמה אפשרויות מאשר לענות בביטחון על השאלה הלא נכונה. */
    var second = hits[1] ? hits[1].s : 0;
    if (top && (top.s >= 1.0 || (top.s >= 0.45 && top.s - second >= 0.35))) {
      serveEntry(top.e);
      return;
    }

    // אין התאמה חד משמעית. אם יש מוח, הוא יבין את השאלה ויענה עליה.
    if (aiAvailable()) { askAI(text, hits); return; }

    localAnswer(text, hits);
  }


  /* ------------------------------------------------------------- המוח

     כשהמאגר המקומי לא מחזיר התאמה חד משמעית, השאלה נשלחת לשרת קטן שמחזיק
     את המפתח ומדבר עם Claude. יחד עם השאלה נשלחות גם התשובות המאושרות
     הקרובות ביותר, כדי שהמוח יישען עליהן ולא ימציא.

     אם אין כתובת שרת מוגדרת, או שהוא לא זמין, פיצי חוזרת להתנהגות המקומית.
     ------------------------------------------------------------------ */
  var AI_TIMEOUT = 25000;

  function aiAvailable() {
    return !!(CFG.aiUrl && window.fetch);
  }

  function askAI(text, hits, chatty) {
    busy = true;
    var tr = typing();
    var done = false;
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) { try { ctrl.abort(); } catch (e) { } } }, AI_TIMEOUT);

    function giveUp() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      tr.remove();
      busy = false;
      if (chatty) { handleIntent('greet', text); return; }
      localAnswer(text, hits);
    }

    var candidates = (hits || []).slice(0, 5).map(function (h) {
      return { q: h.e.q, a: (h.e.a || []).join(' ') };
    });

    fetch(CFG.aiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        messages: convo.slice(-8),
        page: location.pathname,
        candidates: candidates
      }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        tr.remove();
        busy = false;

        if (!d || !d.reply) { if (chatty) { handleIntent('greet', text); } else { localAnswer(text, hits); } return; }

        var html = String(d.reply).split(/\n+/).filter(Boolean).map(function (para) {
          return '<p>' + esc(para) + '</p>';
        }).join('');

        if (d.product) html += productCard(d.product);

        convo.push({ role: 'assistant', content: String(d.reply) });
        if (convo.length > 12) convo = convo.slice(-12);

        /* בשיחת חולין לא תוקעים כפתור נציג בסוף כל משפט. זה קוטע את השיחה. */
        say(html, chatty ? {} : {
          chips: [
            { label: t('askHuman', 'לדבר עם נציג'), act: humanHandoff },
            { label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }
          ]
        });
        logAI(text, String(d.reply));
        persist();
        track('ai', text);
      })
      .catch(giveUp);
  }

  /* ההתנהגות המקומית: הצעות אם יש משהו קרוב, אחרת הודעת לא ידעתי */
  function localAnswer(text, hits) {
    var top = hits && hits[0];
    if (top && top.s >= 0.25) {
      var sug = hits.filter(function (h) { return h.s >= 0.2; }).slice(0, 4);
      botSay('<p>' + esc(t('didYouMean', 'רגע, לא בטוחה שהבנתי במדויק. התכוונת לאחת מאלה?')) + '</p>', {
        chips: sug.map(function (h) { return { label: h.e.q, id: h.e.id }; })
          .concat([{ label: t('noneOfThese', 'לא, משהו אחר'), act: fallback }])
      });
      track('suggest', text);
      return;
    }
    fallback(text);
  }


  /* --------------------------------------------------------- שיחה חיה

     כשהלקוחה מבקשת נציג, נפתחת שיחה בשרת ואתה מקבל התראה בטלגרם.
     שלושה מצבים:
       bot      פיצי עונה כרגיל
       waiting  הודעת לנציג. פיצי ממשיכה לנסות לעזור בינתיים.
       live     הנציג נכנס. פיצי שותקת לגמרי עד שהוא יוצא.
     ------------------------------------------------------------------ */
  var live = { id: null, status: 'bot', since: 0, timer: null, banner: null };
  var LIVE_KEY = 'pitzi_conv_v1';
  /* since ו status נשמרים גם הם. בלעדיהם, מעבר בין עמודים גורם ל poll
     לבקש הכול מאפס, וכל הודעות הנציג מצטיירות שוב מעל אלה שכבר שוחזרו. */
  var LIVE_META_KEY = 'pitzi_conv_meta_v1';
  var POLL_MS = 3000;
  var HANDOFF_TIMEOUT = 10000;
  var handoffPending = false;

  function saveLiveMeta() {
    ss(LIVE_META_KEY, live.since + '|' + live.status);
  }

  function clearLive() {
    stopPolling();
    live.id = null;
    live.since = 0;
    live.status = 'bot';
    try { sessionStorage.removeItem(LIVE_KEY); sessionStorage.removeItem(LIVE_META_KEY); } catch (e) { }
  }

  function liveAvailable() { return !!(CFG.aiUrl && window.fetch); }

  function apiUrl(path) {
    var base = String(CFG.aiUrl || '').replace(/\/+$/, '');
    return base + path;
  }

  function setBanner(text) {
    if (!live.banner) {
      live.banner = el('div', 'pz-live');
      panel.insertBefore(live.banner, body);
    }
    live.banner.innerHTML = '<i class="pz-live-dot"></i>' + esc(text);
    live.banner.style.display = '';
  }

  function clearBanner() {
    if (live.banner) live.banner.style.display = 'none';
  }

  /* הלקוחה ביקשה נציג.
     כלל: לא מבטיחים לה שנציג עודכן לפני שהשרת אישר שההתראה באמת יצאה.
     הבטחה כוזבת כאן היא הגרועה מכל, כי היא גורמת ללקוחה להפסיק לנסות. */
  function requestHuman(silent) {
    if (!liveAvailable()) { humanHandoff(); return; }
    if (handoffPending) return;
    if (live.status === 'waiting' || live.status === 'live') {
      // כבר ביקשה. במקום שקט מוחלט, מזכירים לה איפה הדברים עומדים.
      if (!silent) {
        setBanner(t('waitingBanner', 'העברתי את השיחה לנציג. בינתיים אני כאן.'));
        botSay('<p>' + esc(t('alreadyWaiting', 'הבקשה שלך כבר אצל הנציג ואני לא שולחת אותה פעמיים. אם זה דחוף, אפשר גם לכתוב לנו למייל mypitz3@gmail.com.')) + '</p>',
          { chips: [{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }] });
      }
      return;
    }

    var payload = {
      convId: live.id || ss(LIVE_KEY) || undefined,
      page: location.pathname,
      history: convo.slice(-12).map(function (m) {
        return { role: m.role, text: m.content };
      })
    };

    handoffPending = true;
    var tr = silent ? null : typing();
    var settled = false;
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (ctrl) { try { ctrl.abort(); } catch (e) { } }
    }, HANDOFF_TIMEOUT);

    function done() {
      if (settled) return true;
      settled = true;
      handoffPending = false;
      clearTimeout(timer);
      if (tr) tr.remove();
      return false;
    }

    /* כשל אמיתי. אומרים את זה בפה מלא ונותנים ערוץ חלופי. */
    function failed() {
      if (done()) return;
      clearBanner();
      track('handoff_failed', '');
      botSay('<p>' + esc(t('handoffFailed', 'לא הצלחתי להשיג נציג ברגע זה, ואני לא רוצה להגיד לך שמישהו בדרך כשאני לא בטוחה. אפשר לכתוב לנו למייל mypitz3@gmail.com ונחזור אלייך, או לנסות שוב עוד רגע.')) + '</p>',
        { chips: [{ label: t('tryAgain', 'לנסות שוב'), act: function () { requestHuman(false); } },
                  { label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }] });
    }

    fetch(apiUrl('/api/handoff'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.convId) { failed(); return; }

        /* השרת מדווח אם ההתראה באמת יצאה. telegram הוא אובייקט {sent, error}.
           גם כשההתראה נכשלה השיחה נשמרת בשרת, אבל אסור להבטיח מענה. */
        var alerted = !d.telegram || d.telegram.sent !== false;
        if (!alerted) {
          if (done()) return;
          live.id = d.convId;
          ss(LIVE_KEY, d.convId);
          clearBanner();
          track('handoff_no_alert', d.convId);
          botSay('<p>' + esc(t('handoffNoAlert', 'רשמתי את הפנייה שלך, אבל ההתראה לנציג לא יצאה כרגע ואני לא רוצה להבטיח לך מענה מיידי. הכי בטוח לכתוב לנו למייל mypitz3@gmail.com.')) + '</p>',
            { chips: [{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }] });
          return;
        }

        if (done()) return;
        live.id = d.convId;
        live.status = d.status || 'waiting';
        live.since = 0;
        ss(LIVE_KEY, d.convId);
        saveLiveMeta();
        setBanner(t('waitingBanner', 'העברתי את השיחה לנציג. בינתיים אני כאן.'));
        startPolling();
        track('handoff_live', live.id);
        if (!silent) {
          botSay('<p>' + esc(t('handoffSent', 'עדכנתי נציג עכשיו והוא יצטרף לכאן ברגע שיוכל. בינתיים אני ממשיכה, אז אם יש עוד משהו שאני יכולה לבדוק לך, שאלי אותי.')) + '</p>' +
            agentButton(), { chips: [{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }] });
        }
      })
      .catch(failed);
  }

  function startPolling() {
    if (live.timer) return;
    live.timer = setInterval(pollLive, POLL_MS);
    pollLive();
  }

  function stopPolling() {
    if (live.timer) { clearInterval(live.timer); live.timer = null; }
  }

  function pollLive() {
    if (!live.id) { stopPolling(); return; }
    fetch(apiUrl('/api/poll?c=' + encodeURIComponent(live.id) + '&since=' + live.since))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d) return;
        var was = live.status;
        live.status = d.status || 'bot';

        (d.messages || []).forEach(function (m) {
          if (m.id <= live.since) return;   // כבר הוצגה, לא מציירים פעמיים
          live.since = m.id;
          if (m.role === 'agent') {
            var row = el('div', 'pz-row');
            row.appendChild(el('div', 'pz-mini pz-agent-av', AGENT_ICON));
            row.appendChild(el('div', 'pz-bub pz-agent', '<span class="pz-who">' +
              esc(t('agentName', 'נציג')) + '</span>' + esc(m.text)));
            body.appendChild(row);
            scrollDown();
            if (liveRegion) liveRegion.textContent = m.text;
          } else if (m.role === 'system') {
            var sep = el('div', 'pz-sep', esc(m.text));
            body.appendChild(sep);
            scrollDown();
          }
        });

        if (live.status === 'live') {
          setBanner(t('liveBanner', 'אתה מדבר עכשיו עם נציג'));
          input.placeholder = t('livePlaceholder', 'כתבי לנציג...');
        } else if (live.status === 'waiting') {
          setBanner(t('waitingBanner', 'העברתי את השיחה לנציג. בינתיים אני כאן.'));
          input.placeholder = t('placeholder', 'כתבי לי מה מעניין אותך…');
        } else {
          clearBanner();
          input.placeholder = t('placeholder', 'כתבי לי מה מעניין אותך…');
          /* כל חזרה למצב בוט מסיימת את השיחה, לא רק יציאה ממצב live.
             קודם, שחרור בזמן המתנה השאיר פולינג אינסופי על שיחה מתה. */
          if (was !== 'bot') { clearLive(); }
        }
        saveLiveMeta();
        if (d.messages && d.messages.length) persist();
      })
      .catch(function () { });
  }

  /* שולח לשרת שורה שפיצי אמרה, כדי שהנציג יראה את השיחה המלאה */
  function noteToAgent(role, text) {
    if (!live.id || !liveAvailable()) return;
    fetch(apiUrl('/api/note'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ convId: live.id, role: role, text: text, page: location.pathname })
    }).catch(function () { });
  }

  /* שולח לשרת הודעה של הלקוחה.
     במצב live פיצי שותקת, ולכן כשל כאן אומר שההודעה נעלמה בלי שאף אחד ידע.
     במקרה כזה מסמנים את זה ללקוחה במקום לבלוע. */
  function sayToAgent(text) {
    if (!live.id || !liveAvailable()) return;
    fetch(apiUrl('/api/say'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ convId: live.id, text: text, page: location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('say failed'); return r.json(); })
      .then(function (d) { if (!d || d.error) throw new Error('say rejected'); })
      .catch(function () {
        var sep = el('div', 'pz-sep', esc(t('sayFailed', 'ההודעה הזאת לא נשלחה. בדקי חיבור ונסי שוב.')));
        body.appendChild(sep);
        scrollDown();
        persist();
      });
  }

  /* משחזר שיחה חיה אחרי מעבר בין עמודים.
     חייבים לשחזר גם את since, אחרת ה poll הראשון מבקש את כל התמליל מאפס
     והודעות הנציג נצבעות שוב מעל אלה ש restore כבר החזיר מהאחסון. */
  function resumeLive() {
    var saved = ss(LIVE_KEY);
    if (!saved || !liveAvailable()) return;
    live.id = saved;
    var meta = String(ss(LIVE_META_KEY) || '').split('|');
    live.since = parseInt(meta[0], 10) || 0;
    live.status = (meta[1] === 'live' || meta[1] === 'waiting') ? meta[1] : 'waiting';
    if (live.status === 'live') {
      setBanner(t('liveBanner', 'אתה מדבר עכשיו עם נציג'));
    } else {
      setBanner(t('waitingBanner', 'העברתי את השיחה לנציג. בינתיים אני כאן.'));
    }
    startPolling();
  }

  function followUps(e) {
    var out = [];
    (e.next || []).forEach(function (id) {
      var m = KB.filter(function (x) { return x.id === id; })[0];
      if (m) out.push({ label: m.q, id: m.id });
    });
    if (!e.handoff) out.push({ label: t('askHuman', 'לדבר עם נציגה'), act: function () { requestHuman(false); } });
    out.push({ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu });
    return out;
  }

  var FALLBACKS = CFG.fallbacks || [
    'זאת שאלה שאני עוד לא יודעת לענות עליה לבד, ואני מעדיפה לא לנחש. אפשר לשאול אותי אחרת, או שאעביר אותך לנציגה אנושית.',
    'לא מצאתי תשובה מדויקת לזה אצלי. נסי לנסח בכמה מילים אחרות, או שנעביר את זה לבן אדם שיענה לך בדיוק.',
    'כאן אני נעצרת. במקום לתת לך תשובה חלקית, עדיף שנציג אנושי יענה לך ישירות כאן בצאט.'
  ];

  function fallback(text) {
    var i = (lastFallback + 1) % FALLBACKS.length;
    lastFallback = i;
    if (typeof text === 'string' && text) logMiss(text);
    botSay('<p>' + esc(FALLBACKS[i]) + '</p>' + agentButton(), {
      chips: (CFG.popular || []).map(function (q) { return { label: q }; }).concat([{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }])
    });
    track('fallback', typeof text === 'string' ? text : '');
  }

  function humanHandoff() {
    botSay('<p>' + esc(t('humanText', 'בשמחה. הכי מהיר זה וואטסאפ, ואפשר גם במייל. עונים בדרך כלל באותו יום עסקים.')) + '</p>' +
      agentButton(),
      { chips: [{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }] });
    if (liveAvailable()) requestHuman(true);
    track('handoff', '');
  }

  function handleIntent(id, text) {
    switch (id) {
      case 'greet':
        botSay('<p>' + esc(t('greetBack', 'היי, כיף שבאת. אני פיצי, ואני כאן בשביל כל שאלה על MyPitz.')) + '</p>', { menu: true });
        return true;
      case 'thanks':
        botSay('<p>' + esc(t('thanksBack', 'בכיף. אם יעלה עוד משהו, אני כאן.')) + '</p>', {
          chips: [{ label: t('backToMenu', 'חזרה לתפריט'), act: showMenu }]
        });
        return true;
      case 'bye':
        botSay('<p>' + esc(t('byeBack', 'שיהיה לך יום יבש ורגוע. אני כאן מתי שתצטרכי.')) + '</p>');
        return true;
      case 'human':
        if (liveAvailable()) requestHuman(false);
        else humanHandoff();
        return true;
      case 'bot':
        botSay('<p>' + esc(t('aboutBot', 'אני פיצי, עוזרת אוטומטית של MyPitz. אני לא בן אדם ואני לא ממציאה תשובות. מה שאני לא יודעת, אני מעבירה לנציגה אמיתית.')) + '</p>', { menu: true });
        return true;
      case 'english':
        botSay('<p>' + esc(t('englishText', 'I can answer in English too. Ask me anything about sizing, shipping or returns, or tap below and a human will join this chat.')) + '</p>' + agentButton());
        return true;
      case 'finder':
        if (FINDER) { startFlow(FINDER, 'finder'); return true; }
        return false;
      case 'sizer':
        if (SIZER) { startFlow(SIZER, 'sizer'); return true; }
        return false;
      case 'order':
        var oe = KB.filter(function (x) { return x.id === 'shipping-track-order'; })[0];
        if (oe) { serveEntry(oe); return true; }
        return false;
    }
    return false;
  }

  /* ------------------------------------------------- מדידה ולוג שאלות */
  function track(kind, label) {
    try {
      window.dispatchEvent(new CustomEvent('pitzi:event', { detail: { kind: kind, label: label } }));
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'pitzi_' + kind, pitzi_label: label });
      }
    } catch (e) { }
  }

  var AILOG_KEY = 'pitzi_ai_v1';

  function logAI(q, a) {
    try {
      var arr = JSON.parse(ls(AILOG_KEY) || '[]');
      arr.push({ q: q, a: a, p: location.pathname });
      if (arr.length > 80) arr = arr.slice(-80);
      ls(AILOG_KEY, JSON.stringify(arr));
    } catch (e) { }
  }

  function logMiss(q) {
    try {
      var arr = JSON.parse(ls(MISS_KEY) || '[]');
      arr.push({ q: q, p: location.pathname });
      if (arr.length > 120) arr = arr.slice(-120);
      ls(MISS_KEY, JSON.stringify(arr));
    } catch (e) { }
  }

  /* ------------------------------------------------------ שמירת שיחה */
  function persist() {
    try { ss(STORE_KEY, body.innerHTML); } catch (e) { }
  }

  function restore() {
    var saved = ss(STORE_KEY);
    if (!saved) return false;
    body.innerHTML = saved;
    // הכפתורים שנשמרו כ-HTML איבדו מאזינים — מחליפים אותם בטקסט לחיץ מחדש
    Array.prototype.forEach.call(body.querySelectorAll('.pz-chip'), function (b) {
      b.addEventListener('click', function () {
        if (busy) return;
        ask(b.getAttribute('data-q') || b.textContent.trim(), b.getAttribute('data-id') || null);
      });
    });
    Array.prototype.forEach.call(body.querySelectorAll('.pz-mi'), function (b) {
      b.addEventListener('click', function () {
        if (busy) return;
        var label = b.querySelector('b') ? b.querySelector('b').textContent.trim() : '';
        var m = MENU.filter(function (x) { return x.label === label; })[0];
        if (m) openCategory(m);
      });
    });
    scrollDown(false);
    return true;
  }

  function reset() {
    body.innerHTML = '';
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { }
    flow = null;
    convo = [];
    stopPolling();
    live.id = null; live.status = 'bot'; live.since = 0;
    clearBanner();
    try { sessionStorage.removeItem(LIVE_KEY); } catch (e) { }
    greet();
  }

  function greet() {
    say('<p>' + (CFG.welcome || 'היי, אני <strong>פיצי</strong> 👋<br>אני כאן כדי לענות על כל שאלה על MyPitz. מוצרים, מידות, משלוחים והחזרות. מה מעניין אותך?') + '</p>', { menu: true });
  }

  /* ------------------------------------------------------------- בנייה */
  function build() {
    root = el('div');
    root.id = 'pitzi-root';

    launcher = el('button', 'pz-launcher', MASCOT.replace('<svg ', '<svg class="pz-face" ') + ICON_X);
    launcher.type = 'button';
    launcher.setAttribute('aria-label', t('openLabel', 'פתיחת הצ\'אט עם פיצי'));
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-controls', 'pitzi-panel');

    teaser = el('div', 'pz-teaser', CFG.teaser || 'היי, אני <b>פיצי</b>. שאלה על מידות, משלוח או איך זה עובד?');
    var tx = el('button', 'pz-teaser-x', '&times;');
    tx.type = 'button';
    tx.setAttribute('aria-label', t('closeTeaser', 'סגירת ההודעה'));
    tx.addEventListener('click', function (ev) { ev.stopPropagation(); hideTeaser(true); });
    teaser.appendChild(tx);
    teaser.addEventListener('click', function () { hideTeaser(true); open(); });

    panel = el('div', 'pz-panel');
    panel.id = 'pitzi-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-label', t('panelLabel', 'צ\'אט עם פיצי, העוזרת של MyPitz'));

    var head = el('div', 'pz-head');
    head.appendChild(el('div', 'pz-av', MASCOT));
    var ht = el('div', 'pz-head-t', '<strong>' + esc(C.name) + '</strong><span><i class="pz-dot"></i>' + esc(C.subtitle) + '</span>');
    head.appendChild(ht);

    var hb = el('div', 'pz-head-btns');
    backBtn = el('button', 'pz-hb', ICON_RESET);
    backBtn.type = 'button';
    backBtn.setAttribute('aria-label', t('resetLabel', 'להתחיל שיחה מחדש'));
    backBtn.setAttribute('title', t('resetLabel', 'להתחיל שיחה מחדש'));
    backBtn.addEventListener('click', reset);
    var closeBtn = el('button', 'pz-hb', ICON_BACK);
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', t('closeLabel', 'סגירת הצ\'אט'));
    closeBtn.setAttribute('title', t('closeLabel', 'סגירת הצ\'אט'));
    closeBtn.addEventListener('click', close);
    hb.appendChild(backBtn);
    hb.appendChild(closeBtn);
    head.appendChild(hb);

    body = el('div', 'pz-body');
    body.setAttribute('role', 'log');
    body.setAttribute('aria-live', 'polite');
    body.setAttribute('aria-relevant', 'additions');

    liveRegion = el('div');
    liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
    liveRegion.setAttribute('aria-live', 'polite');

    var foot = el('div', 'pz-foot');
    var iw = el('div', 'pz-inputwrap');
    input = el('textarea', 'pz-input');
    input.rows = 1;
    input.placeholder = t('placeholder', 'כתבי לי מה מעניין אותך…');
    input.setAttribute('aria-label', t('inputLabel', 'הקלדת הודעה לפיצי'));
    input.setAttribute('enterkeyhint', 'send');
    sendBtn = el('button', 'pz-send', ICON_SEND);
    sendBtn.type = 'button';
    sendBtn.disabled = true;
    sendBtn.setAttribute('aria-label', t('sendLabel', 'שליחה'));
    iw.appendChild(input);
    iw.appendChild(sendBtn);
    foot.appendChild(iw);
    foot.appendChild(el('div', 'pz-legal', t('legal', 'פיצי היא עוזרת אוטומטית. לשאלות אישיות או רפואיות מומלץ לפנות אלינו ישירות.')));

    panel.appendChild(head);
    panel.appendChild(body);
    panel.appendChild(foot);

    root.appendChild(teaser);
    root.appendChild(panel);
    root.appendChild(launcher);
    root.appendChild(liveRegion);
    document.body.appendChild(root);

    launcher.addEventListener('click', toggle);
    launcher.addEventListener('pointerenter', function () { loadKB(); });
    teaser.addEventListener('pointerenter', function () { loadKB(); });
    sendBtn.addEventListener('click', function () { ask(input.value); });
    input.addEventListener('input', function () { sendBtn.disabled = !input.value.trim(); autoGrow(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); ask(input.value); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { close(); }
    });

    autoGrow();
    wireAgentButtons();
    resumeLive();
    if (!restore()) greet();
    adjustForStickyBar();
    maybeTeaser();
  }

  var LINE_H = 24, BASE_H = 38, MAX_H = 96;
  /* גובה שדה הכתיבה מחושב לפי מספר השורות ולא לפי scrollHeight.
     scrollHeight לא אמין כאן כי השדה הוא פריט flex בתוך מיכל עם align-items:flex-end,
     והוא החזיר את גובה המקסימום גם לשורה אחת. */
  function autoGrow() {
    var val = input.value;
    if (!val) { input.style.height = BASE_H + 'px'; return; }
    var w = input.clientWidth - 20;
    var perLine = w > 40 ? Math.floor(w / 8.2) : 38;   // רוחב ממוצע של תו עברי ב-16px
    var lines = 0;
    val.split('\n').forEach(function (l) {
      lines += Math.max(1, Math.ceil(l.length / perLine));
    });
    input.style.height = Math.min(MAX_H, BASE_H + (lines - 1) * LINE_H) + 'px';
  }

  function open() {
    if (isOpen) return;
    lastFocus = document.activeElement;
    isOpen = true;
    root.classList.add('pz-open');
    launcher.setAttribute('aria-expanded', 'true');
    launcher.setAttribute('aria-label', t('closeLabel', 'סגירת הצ\'אט'));
    launcher.classList.remove('pz-pulse');
    hideTeaser(true);
    var badge = launcher.querySelector('.pz-badge');
    if (badge) badge.remove();
    ls(SEEN_KEY, '1');
    loadKB();
    setTimeout(function () {
      autoGrow();
      if (window.matchMedia('(min-width:601px)').matches) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
      scrollDown(false);
    }, 240);
    track('open', location.pathname);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('pz-open');
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-label', t('openLabel', 'פתיחת הצ\'אט עם פיצי'));
    try { (lastFocus && lastFocus.focus) ? lastFocus.focus() : launcher.focus(); } catch (e) { }
  }

  function toggle() { isOpen ? close() : open(); }

  function hideTeaser(permanent) {
    if (!teaser) return;
    teaser.classList.remove('pz-show');
    if (permanent) ss('pitzi_teaser_hidden', '1');
  }

  function maybeTeaser() {
    if (ss('pitzi_teaser_hidden')) return;
    if (!ls(SEEN_KEY)) {
      var b = el('span', 'pz-badge', '1');
      launcher.appendChild(b);
      launcher.classList.add('pz-pulse');
    }
    setTimeout(function () {
      if (!isOpen && !ss('pitzi_teaser_hidden')) teaser.classList.add('pz-show');
    }, C.teaserDelay);
  }

  /* מרים את הכפתור מעל סרגל ההוספה לסל בעמודי מוצר */
  function adjustForStickyBar() {
    function measure() {
      var bar = document.querySelector('.sticky-atc, .product-sticky, [data-sticky-atc]');
      if (bar && bar.offsetParent !== null) {
        var h = bar.getBoundingClientRect().height;
        if (h > 8) {
          root.classList.add('pz-atc');
          root.style.setProperty('--pz-atc-h', Math.round(h) + 'px');
          return;
        }
      }
      root.classList.remove('pz-atc');
      root.style.removeProperty('--pz-atc-h');
    }
    measure();
    setTimeout(measure, 900);
    setTimeout(measure, 2500);
    window.addEventListener('resize', measure);

    /* סרגל ההוספה לסל במובייל מופיע רק אחרי גלילה, ולכן צריך למדוד שוב
       תוך כדי גלילה. מוגבל לפעם אחת לכל פריים כדי לא להכביד. */
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; measure(); });
    }, { passive: true });
    if (window.ResizeObserver) {
      try {
        var bar = document.querySelector('.sticky-atc');
        if (bar) new ResizeObserver(measure).observe(bar);
      } catch (e) { }
    }
  }

  /* -------------------------------------------------------------- API */
  window.Pitzi = {
    open: open,
    close: close,
    ask: function (q) { open(); setTimeout(function () { ask(q); }, 260); },
    reset: reset,
    ready: function (cb) { loadKB(cb); },
    get size() { return KB.length; },
    /* לבעלי החנות: Pitzi.misses() בקונסול מציג שאלות שלא נמצאה להן תשובה */
    misses: function () { try { return JSON.parse(ls(MISS_KEY) || '[]'); } catch (e) { return []; } },
    /* שאלות שהמוח ענה עליהן. מועמדות מצוינות להוספה למאגר המקומי */
    aiLog: function () { try { return JSON.parse(ls(AILOG_KEY) || '[]'); } catch (e) { return []; } },
    brain: function () { return aiAvailable() ? CFG.aiUrl : false; },
    /* מצב השיחה החיה: bot, waiting או live */
    liveStatus: function () { return live.status; },
    callHuman: function () { open(); setTimeout(function () { requestHuman(false); }, 260); },
    clearMisses: function () { try { localStorage.removeItem(MISS_KEY); } catch (e) { } },
    search: function (q) {
      if (!kbReady) { loadKB(); return 'מאגר הידע עדיין נטען, נסו שוב עוד רגע'; }
      return search(q, []).map(function (h) { return { q: h.e.q, score: +h.s.toFixed(3), id: h.e.id }; });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
